import React, {useEffect, useState} from 'react'
import {Button, Modal, Row, Select} from "antd";
import {getBrandByMatchedEmployee} from "../../services/serviceEmployeeBrand";
import {createBrandRepresentative, deleteRepresentative} from "../../services/serviceEmployeeBrand";

const EmployeeBrandMatch = ({employeeId, show, modalCloser, brandList}) => {
    const [representativeFor, setRepresentativeFor] = useState([]);
    const [selectedBrands, setSelectedBrands] = useState([]);
    const [startRead, setStartRead] = useState(false);

    useEffect(() => {
        getBrandByMatchedEmployee(employeeId)
            .then(({data}) => {
                setSelectedBrands(data.map(item => item.brand.id))
                setRepresentativeFor(data)
                setStartRead(!startRead)
            })
    }, []);

    const findMatchId = (brandId) => {
        const defined = representativeFor.find(i => i.brand.id === brandId);
        return defined.id;
    };

    const handleDeSelect = async (val) => {
        const match = findMatchId(val);
        if(match) {
            await deleteRepresentative(match);
        } else {
            return;
        }
    };

    const handleCheck = async (val) => {
        await createBrandRepresentative({
            brand: {
                id: val
            },
            employee: {
                id: employeeId
            }
        });
    };

    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'));
    };

    return(
        <React.Fragment>
            <Modal
                open={show}
                title={'Marka Eşleştir'}
                closable={false}
                footer={[
                    <Button
                        key={'CancelButton'}
                        onClick={modalCloser}
                    >
                        Kapat
                    </Button>
                ]}
            >
                {
                    startRead ? 
                    <Row>
                        <Select 
                            options={brandList} 
                            mode={'multiple'}
                            style={{width: '100%'}} 
                            showSearch 
                            filterOption={selectSearch} 
                            allowClear 
                            placeholder={'Marka Seçiniz'}
                            onSelect={handleCheck}
                            onDeselect={handleDeSelect}
                            defaultValue={selectedBrands}
                        />
                    </Row> : null
                }
            </Modal>
        </React.Fragment>
    )
}
export default EmployeeBrandMatch